import sanitizeHtml from 'sanitize-html';

export const sanitizeTelegramHtml = (html: string): string => {
  const withLineBreaks = html
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/(div|p)>/gi, '\n')
    .replace(/<(div|p)[^>]*>/gi, '');

  return sanitizeHtml(withLineBreaks, {
    allowedTags: ['b', 'strong', 'i', 'em', 'u', 's', 'a', 'code', 'pre'],
    allowedAttributes: {
      a: ['href'],
    },
    allowedSchemes: ['http', 'https', 'mailto'],
    transformTags: {
      strong: 'b',
      em: 'i',
    },
  })
    .replace(/^\s+/, '')
    .replace(/[ \t]+$/, '')
    .replace(/\n{2,}$/, '\n');
};

export const stripAllFormatting = (html: string): string => {
  const withLineBreaks = html
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/(div|p)>/gi, '\n')
    .replace(/<(div|p)[^>]*>/gi, '');

  return sanitizeHtml(withLineBreaks, {
    allowedTags: [],
    allowedAttributes: {},
  })
    .replace(/^\s+/, '')
    .replace(/[ \t]+$/, '')
    .replace(/\n{2,}/g, '\n');
};
